import { createSelector } from 'reselect'

const getActiveParameters = (state) => state.searchParams.activeParameters

export const getSortOrderParameter = createSelector(
  [getActiveParameters],
  (activeParameters) => activeParameters.find((parameter) => parameter.dataGroup === 'sort_orders'),
)
